const types = {
  SET_LISTA_TIPOS_DOCUMENTAIS: 'SET_LISTA_TIPOS_DOCUMENTAIS',
  SET_TIPO_SELECIONADO: 'SET_TIPO_SELECIONADO',
  SET_PROPRIEDADES: 'SET_PROPRIEDADES',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING'
}

export default types
